
const Ui3DotsMenu = {
  Common: {
    editEntity: 'Edit {{ENTITY}}',
    deleteEntity: 'Delete {{ENTITY}}',
  },
  Candidate: {
    PREFIX: 'Candidate: ',
    ENTITY: 'candidate',
    downloadResume: '{{PREFIX}}download resume (download CV{{COUNTER}})',
    viewResumeHighlights: '{{PREFIX}}view resume highlights',
    viewResumeText: '{{PREFIX}}view text resume',
    viewResume: '{{PREFIX}}view resume',
    viewScrubbedResume: 'View Scrubbed Resume',
  },
  Engagement: {
    PREFIX: 'Engagement: ',
    ENTITY: 'engagement',
  },
  Job: {
    PREFIX: 'Job: ',
    ENTITY: 'job',
    clone: 'Clone job',
    close: 'Close job',
    edit: 'Edit job',
    employerPendings: 'Employer portal',
    intakeAttendance: 'Record job intake attendance',
    match: 'Match job',
    previewRecruiterJobUpdates: 'Notify recruiter (job updates)',
  },
  Account: {
    PREFIX: 'Account: ',
    ENTITY: 'account',
  },
  Employer: {
    PREFIX: 'Employer: ',
    ENTITY: 'employer',
    intakeAttendance: 'Record employer intake attendance',
    previewRecruiterEmployerUpdates: 'Notify recruiter (employer updates)',
  },
  Recruiter: {
    PREFIX: 'Recruiter: ',
    ENTITY: 'recruiter',
  },
}

export default Ui3DotsMenu;
